import setup from "./setup";
setup();

import makeChart from "./map";
let stateTopo = require("../data/usa_states_20m_2017.topo.json");
let theData = require("../data/data.json");

function main() {

  const theChart = new makeChart({
    element: document.querySelector(".map"),
    stateTopo,
    data: theData
  });

  window.addEventListener("optimizedResize", () => {
    theChart.update();
  });
}
window.onload = main;
